if (!customElements.get('category-tabs')) {
  customElements.define(
    'category-tabs',
    class CategoryTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
        });
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === selectedTab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }
    }
  );
}
